import axios from '../../api/axiosClient';

export const fetchCartItems = async (setCartItems) => {
  const response = await axios.get('/api/cart/');
  setCartItems(response.data[0]?.cart_items || []);
};

export const updateCartItemQuantity = async (itemId, newQuantity, onSuccess) => {
  const response = await axios.patch('/api/cart/update-item/', {
    composition_id: itemId,
    quantity: newQuantity,
  });
  if (response.data.status === 'success') {
    await onSuccess();
  }
};

export const removeCartItem = async (itemId, onSuccess) => {
  const response = await axios.delete('/api/cart/delete-item/', {
    data: { composition_id: itemId },
  });
  if (response.data.status === 'success') {
    await onSuccess();
  }
};

export const submitOrder = async (orderData) => {
  return axios.post('/api/order/', orderData);
};

export const fetchDistricts = async () => {
  const response = await axios.get('/api/delivery-district/');
  return response.data;
};

export const fetchDeliveryPrice = async (districtId, time) => {
  const response = await axios.post('/api/cart/price-delivery/', {
    district_id: districtId,
    time: time,
  });
  return response.data.price;
};
